module.exports = __webpack_public_path__ + "static/media/icon-menu-white.1f73316d.svg";